import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Reports } from '../reports.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Globle } from 'src/assets/globle';

@Component({
  selector: 'app-ordersreports',
  templateUrl: './ordersreports.component.html',
  styleUrls: ['./ordersreports.component.css']
})
export class OrdersreportsComponent implements OnInit {

  reports: Reports[] = [];
  displayedColumns: string[] = ['orderId', 'userName', 'userCatg', 'product',
    "quantity", "total", "costPrice", "date", "CardsNumber", "phoneInfo"];
  dataSource!: MatTableDataSource<Reports>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false
  lang = 'en';
  reportObj: Reports = {} as Reports
  totalRowsCount = 0;
  currentPage = 0;
  pageSize = 10;
  searchByName: string = "";
  sumTotals = 0;
  sumCostPrice = 0;
  constructor(private service: ReportsService,
    private translate: TranslateService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
  }

  get(getTotals: boolean) {
    console.log(this.pageSize)
    this.spinnerOverlay = true;
    this.service.getAllByDate(this.fromDate.nativeElement.value, this.toDate.nativeElement.value,
      this.searchByName, getTotals, this.currentPage + 1, this.pageSize).subscribe(data => {
        this.reports = data.data;
        if (getTotals) {
          this.sumTotals = data.totals.sumTotal;
          this.sumCostPrice = data.totals.sumCostPrice;
        }
        this.dataSource = new MatTableDataSource(this.reports);
        this.paginator = {} as MatPaginator;
        this.paginator.pageIndex = this.currentPage;
        this.paginator.pageSize = this.pageSize;
        this.paginator.length = data.pagination.totalCount;
        this.totalRowsCount = data.pagination.totalCount;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
          this.reports = [];
          this.dataSource = new MatTableDataSource(this.reports);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
  }

  pageChanged(event: PageEvent) {
    this.pageSize = +event.pageSize;
    this.currentPage = +event.pageIndex;
    console.log(this.pageSize)
    console.log(this.currentPage)
    this.get(false);
  }

  onApply() {
    this.get(true);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف طلبات كلي ", 90, 10);
    doc.text("_________________________________", 50, 12);


    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#ordersTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  sumProfit() {
    return (this.sumTotals - this.sumCostPrice).toFixed(3)
  }
}
